<template>
    <div class="question-simu checkbox-question">
        <h2 class="question-simu__title" :inner-html.prop="questionDatas.title"></h2>

        <ul 
            class="answers__container grid-container"
            :class="gridClass"
        >
            <li 
                v-for="(answer, index ) in questionDatas.options"
                v-show="!hideAnswerOption(answer.value)"
                class="answers__card answer" 
                :class="{selected: answer.value === currentAnswer}"
                :key="index"
                @click="handleAnswer(questionDatas, answer)"
            >
                <img :src="`${mediaBaseUrl}${answer.picto}`"  class="answer__picto"/>
                <span class="answer__label">{{answer.label}}</span>
            </li>
        </ul>

        <!-- Error info -->
        <div 
            class="form-error"
            :class="{displayed: displayErrorMessage}"
        >
            {{errorMessage}}
        </div>
    </div>
</template>

<script>
import { isEven } from "@/services/tools.js";
import { mapGetters } from "vuex";


export default {
    name: "CheckboxQuestion",

    props: {
        questionDatas: {
            type: Object,
            default: {},
        },
        mediaBaseUrl: {
            type: String,
            default: ''
        },
        currentAnswer: {
            type: String,
            default: '',
        },
        displayErrorMessage: {
            type: Boolean,
            default: false
        },
        blogAnswerUrlParams: {
            type: Object,
            default: {}
        },
    },

    data() {
        return {
            gridClass: this.questionDatas.options.length === 1 ? "grid-layout-1" : (isEven(this.questionDatas.options.length) ? "grid-layout-2" : "grid-layout-3"),
            errorMessage: "Vous devez sélectionner une option"
        };
    },

    computed: {
        ...mapGetters({ 
            dwellingStepAnswer: "getDwellingStepAnswers",
        }),
    },

    created() {
        this.handleBlogAnsweredParams();
    },

    methods: {
        /**
         * On go back 
         * Remove to avoid increment multiple same question in form
         * @param {Object} question
         * @param {Object} answer
         */
        removeOldSubQuestion(question, answer){
            if(
                answer.sub_question && answer.sub_question.key === question.key ||
                !answer.sub_question
            ) this.$emit('Remove::sub-question')
        },

        /**
         * Emit question and answer to be saved
         * @param {Object} question
         * @param {Object} answer
         */
        handleAnswer(question, answer) {
            if(question?.hasSubQuestion) this.removeOldSubQuestion(question, answer);
            
            //set subquestion
            if(answer?.sub_question) {
                const overwriteLastAnswer = question.key === answer?.sub_question.key;
                this.$emit('Answer::sub-question', answer.sub_question, overwriteLastAnswer) 
            } 
            
            
            //Send answer
            if(answer?.sub_question && answer?.sub_question.key === question.key) {
                this.$emit('Answer::choice', question.key, answer.value, true)
                this.$emit('Answer::choice', `${question.key}_parent`, answer.value, false)
            } else {
                this.$emit('Answer::choice', question.key, answer?.value, true);
            }
        },

        hideAnswerOption(answerValue) {
            const isHeatingTypeQuestion = this.questionDatas.key === "mcp_current_type_of_heating";
            switch (this.questionDatas.key) {
                case "mcp_current_type_of_heating":
                    return answerValue === "fuel_boiler_generic" && (this.dwellingStepAnswer.mcp_type_of_dwelling == "apartment" || this.dwellingStepAnswer.mcp_type_of_dwelling == "Appartement");
                    break;
            
                default:
                    return false
                    break;
            }
        },

        /**
         * If blog answer is in url params, handle it
         */
        handleBlogAnsweredParams() {
            let urlKey = Object.keys(this.blogAnswerUrlParams)[0];

            if(this.questionDatas.key === urlKey) {
                let answerObject = this.questionDatas.options.find(answer => answer.value === this.blogAnswerUrlParams[urlKey]);
                this.handleAnswer(this.questionDatas, answerObject);
            } 
        }
    },
 
}
</script>

<style lang="scss" scoped>

.checkbox-question {
    .answers {

        &__card {
            cursor: pointer;
            display:flex;
            align-items: center;
            margin: 30px auto;
            padding: 5px 40px 5px 20px;
            background: $color-white;
            color: $c-grey-blue;
            border: 2px solid transparent;
            border-radius: 10px;
            box-shadow: 0 5px 20px rgba(12, 35, 44, 0.1);
            transition: box-shadow .2s ease-out;
            user-select: none;
            

            @include breakpoint(md) {
                padding: 20px 40px 20px 20px;
                margin: 0 0;
            }

            &:hover{
                box-shadow: 0 10px 20px rgba(12, 35, 44, 0.2);
            }
        }  
    }

    .answer {
        position: relative;

        &__picto {
            width: 60px;
            margin-right:30px;

            @include breakpoint(md) {
                width: 80px;
                margin-right:15px;
            }

            @include breakpoint(lg) {
                margin-right:30px;
            }
        }

        &__label {
            font-size: 1.5rem;
            
            @include breakpoint(md) {
                font-size: 1.7rem;
            }
        }

        &.selected {
            border: 2px solid $c-mcp-green;
            box-shadow: none;

            &::after {
                content:"\e91a";
                position: absolute;
                top: 50%;
                right: 15px;
                transform: translateY(-50%);
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: auto;
                width: 24px;
                height: 24px;
                
                font-family: 'icomoon' !important;
                font-size: 1.2rem;
                color: $color-white;
                background-color: $c-mcp-green;
                border-radius: 50%;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
            }
        }

    }
}
</style>